// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__DKbF2","logoTitle":"styles_logoTitle__3ub5C","logoNote":"styles_logoNote__1WK9x"};